import { render, staticRenderFns } from "./aiChatArea.vue?vue&type=template&id=282a84f3&scoped=true"
import script from "./aiChatArea.vue?vue&type=script&lang=js"
export * from "./aiChatArea.vue?vue&type=script&lang=js"
import style0 from "./aiChatArea.vue?vue&type=style&index=0&id=282a84f3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "282a84f3",
  null
  
)

export default component.exports